module.exports = __webpack_public_path__ + "static/html-element-advanced_6-d2653b021ca4c64d82412ee1c7db810c.jpg";